import React, { useCallback, useEffect, useState } from 'react';
import NextYearInterestForm from './NextYearInterestForm';
import './admin/FmModal.css';
import './InterestListModal.css';

function InterestListModal({ fromEditionYear, source = 'archive', triggerText = 'Join next year interest list' }) {
  const [open, setOpen] = useState(false);

  const onKeyDown = useCallback((e) => {
    if (e.key === 'Escape') setOpen(false);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onKeyDown]);

  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  return (
    <>
      <button type="button" className="interest-modal-trigger" onClick={() => setOpen(true)}>
        {triggerText}
      </button>
      {open && (
        <div
          className="fm-modal-overlay interest-modal-overlay"
          role="presentation"
          onClick={() => setOpen(false)}
        >
          <div
            className="fm-modal interest-modal-shell"
            role="dialog"
            aria-modal="true"
            aria-labelledby="interest-list-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="fm-modal-header interest-modal-header">
              <h2 className="fm-modal-title" id="interest-list-modal-title">
                {triggerText}
              </h2>
              <button type="button" className="fm-modal-close" onClick={() => setOpen(false)} aria-label="Close">
                ✕
              </button>
            </div>
            <div className="fm-modal-body interest-modal-body">
              <div className="interest-modal-brand" aria-hidden>
                <img className="interest-modal-logo" src={`${process.env.PUBLIC_URL}/fresh-meet-logo.png`} alt="" />
              </div>
              <NextYearInterestForm
                fromEditionYear={fromEditionYear}
                source={source}
                variant="bare"
                onSuccess={() => setOpen(false)}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InterestListModal;
